import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { euro } from "@/lib/format";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Package, AlertTriangle } from "lucide-react";
import { GiacenzeTab } from "@/components/magazzino/GiacenzeTab";
import { ArticoliTab } from "@/components/magazzino/ArticoliTab";
import { CarichiTab } from "@/components/magazzino/CarichiTab";
import { PrelieviTab } from "@/components/magazzino/PrelieviTab";
import { ResiTab } from "@/components/magazzino/ResiTab";
import { OrdiniMaterialeTab } from "@/components/magazzino/OrdiniMaterialeTab";

export default function Magazzino() {
  const [tab, setTab] = useState("giacenze");
  const { data: giac } = useQuery({ queryKey: ["mag-giacenze", "totali"], queryFn: async () => (await api.get("/magazzino/giacenze", { params: { limit: 1 } })).data });
  return (
    <div className="space-y-6" data-testid="magazzino-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-3"><Package className="h-8 w-8 text-primary" /> Magazzino</h1>
          <p className="text-slate-500 mt-1">Articoli, carichi da DDT, prelievi e giacenze valorizzate a costo medio ponderato.</p>
        </div>
        <div className="flex gap-3">
          <div className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm"><div className="text-xs text-slate-400">Valore magazzino</div><div className="font-mono font-semibold" data-testid="mag-valore-totale">{euro(giac?.valore_totale || 0)}</div></div>
          <div className={`rounded-xl border px-4 py-2 text-sm ${giac?.n_sotto_scorta ? "border-red-200 bg-red-50 text-red-700" : "border-slate-200 bg-white"}`}><div className="text-xs opacity-70">Sotto scorta</div><div className="font-mono font-semibold flex items-center gap-1" data-testid="mag-sotto-scorta">{giac?.n_sotto_scorta ? <AlertTriangle className="h-4 w-4" /> : null}{giac?.n_sotto_scorta || 0}</div></div>
        </div>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="giacenze" data-testid="mag-tab-giacenze">Giacenze</TabsTrigger>
          <TabsTrigger value="articoli" data-testid="mag-tab-articoli">Articoli</TabsTrigger>
          <TabsTrigger value="carichi" data-testid="mag-tab-carichi">Carichi</TabsTrigger>
          <TabsTrigger value="prelievi" data-testid="mag-tab-prelievi">Prelievi</TabsTrigger>
          <TabsTrigger value="resi" data-testid="mag-tab-resi">Resi</TabsTrigger>
          <TabsTrigger value="ordini" data-testid="mag-tab-ordini">Da ordinare</TabsTrigger>
        </TabsList>
        <TabsContent value="ordini" className="mt-4"><OrdiniMaterialeTab /></TabsContent>
        <TabsContent value="giacenze" className="mt-4"><GiacenzeTab /></TabsContent>
        <TabsContent value="articoli" className="mt-4"><ArticoliTab /></TabsContent>
        <TabsContent value="carichi" className="mt-4"><CarichiTab /></TabsContent>
        <TabsContent value="prelievi" className="mt-4"><PrelieviTab /></TabsContent>
        <TabsContent value="resi" className="mt-4"><ResiTab /></TabsContent>
      </Tabs>
    </div>
  );
}
